/**
 * Wrist Pinnacle configuration rules — verified storefront foundation.
 * Current Colorways are synchronized from the live Shopify records on 2026-08-26.
 * The Studio presents verified platform architecture and live Colorways. It does not
 * expose speculative options, generic media, or a checkout path for unlisted builds.
 */
window.WristPinnacleConfigurationRules = {
  version: '2026-08-26.2',
  fulfillmentGate: 'Only a current Shopify Colorway with a verified price, SKU, and matching media may route to checkout.',
  dialInscription: {
    default: 'FIRST EDITION',
    automatic: 'AUTOMATIC / FIRST EDITION',
    rule: 'Use the automatic inscription only when the selected build explicitly records a verified automatic movement.'
  },
  componentCategories: [
    'Case platform',
    'Bezel',
    'Dial',
    'Crown',
    'Calendar or function',
    'Bracelet',
    'Finish or two-tone treatment',
    'Movement',
    'Colorway'
  ],
  optionStates: {
    current: 'Verified platform detail',
    reviewOnly: 'Architecture reference only — not a customer-selectable purchase path'
  },
  models: [
    {
      id: 'facet-01',
      name: 'Facet 01',
      family: 'Integrated Series',
      platform: 'integrated-date',
      purchaseUrl: '/products/facet-01',
      currentColorways: ['Onyx / Ice', 'Slate / Charcoal', 'Gold / Ivory', 'Rose / Midnight', 'Rose / Blush'],
      currentPrice: 329,
      visibleArchitecture: ['integrated bracelet', 'angular bezel case', 'three-hand date layout'],
      excludedFutureGroups: ['GMT hand stack', 'chronograph pushers', 'chronograph dial', 'tachymeter bezel'],
      movementState: 'Verified three-hand date movement.',
      componentOptions: {
        case: [{ value: 'integrated angular date', state: 'current' }],
        bezel: [{ value: 'angular integrated bezel', state: 'current' }],
        dial: [{ value: 'three-hand date dial', state: 'current' }],
        crown: [{ value: 'matching integrated crown', state: 'current' }],
        calendarFunction: [{ value: 'date', state: 'current' }],
        bracelet: [{ value: 'integrated bracelet', state: 'current' }],
        finish: [{ value: 'current Colorway treatments', state: 'current' }],
        movement: [{ value: 'verified three-hand date movement', state: 'current' }]
      }
    },
    {
      id: 'atria-02',
      name: 'Atria 02',
      family: 'Integrated Series',
      platform: 'integrated-date-arabic',
      purchaseUrl: '/products/atria-02',
      currentColorways: ['Steel / Graphite', 'Rose / Ice', 'Steel / Graphite / Gold / Green', 'Rose / Green Radial'],
      currentPrice: 319,
      visibleArchitecture: ['integrated bracelet', 'smooth round bezel', 'Arabic-index three-hand date layout'],
      excludedFutureGroups: ['GMT hand stack', 'chronograph pushers', 'chronograph dial', 'tachymeter bezel'],
      movementState: 'Verified three-hand date movement.',
      componentOptions: {
        case: [{ value: 'integrated round date', state: 'current' }],
        bezel: [{ value: 'smooth round bezel', state: 'current' }],
        dial: [{ value: 'Arabic-index three-hand date dial', state: 'current' }],
        crown: [{ value: 'matching round-case crown', state: 'current' }],
        calendarFunction: [{ value: 'date', state: 'current' }],
        bracelet: [{ value: 'integrated bracelet', state: 'current' }],
        finish: [{ value: 'current Colorway treatments', state: 'current' }],
        movement: [{ value: 'verified three-hand date movement', state: 'current' }]
      }
    },
    {
      id: 'vale-03',
      name: 'Vale 03',
      family: 'Integrated Series',
      platform: 'integrated-no-date',
      purchaseUrl: '/products/vale-03',
      currentColorways: ['Steel / Green', 'Steel / Forest Relief', 'Steel / Cyan'],
      currentPrice: 319,
      visibleArchitecture: ['integrated bracelet', 'smooth round bezel', 'baton-and-triangle no-date layout'],
      excludedFutureGroups: ['date-window dial', 'day-date dial', 'GMT hand stack', 'chronograph pushers', 'chronograph dial', 'tachymeter bezel'],
      movementState: 'Verified no-date movement.',
      componentOptions: {
        case: [{ value: 'integrated no-date case', state: 'current' }],
        bezel: [{ value: 'smooth round bezel', state: 'current' }],
        dial: [{ value: 'baton-and-triangle no-date dial', state: 'current' }],
        crown: [{ value: 'matching round-case crown', state: 'current' }],
        calendarFunction: [{ value: 'no date', state: 'current' }],
        bracelet: [{ value: 'integrated bracelet', state: 'current' }],
        finish: [{ value: 'current Colorway treatments', state: 'current' }],
        movement: [{ value: 'verified no-date movement', state: 'current' }]
      }
    },
    {
      id: 'meridian-04',
      name: 'Meridian 04',
      family: 'Meridian Series',
      platform: 'meridian-gmt',
      purchaseUrl: '/products/meridian-04',
      currentColorways: ['Gold / Black', 'Steel / Green', 'Steel / Teal', 'Steel / Black 24'],
      currentPrice: 329,
      visibleArchitecture: ['sport case', '24-hour bezel', 'GMT hand stack', 'date layout', 'three-link bracelet'],
      excludedFutureGroups: ['tachymeter bezel', 'chronograph pushers', 'chronograph dial', 'day-date dial'],
      movementState: 'Verified GMT-with-date movement.',
      componentOptions: {
        case: [{ value: 'GMT sport case', state: 'current' }],
        bezel: [{ value: '24-hour bezel', state: 'current' }],
        dial: [{ value: 'GMT with date dial', state: 'current' }],
        crown: [{ value: 'matching sport-case crown', state: 'current' }],
        calendarFunction: [{ value: 'GMT with date', state: 'current' }],
        bracelet: [{ value: 'three-link bracelet', state: 'current' }],
        finish: [{ value: 'current Colorway treatments', state: 'current' }],
        movement: [{ value: 'verified GMT-with-date movement', state: 'current' }]
      }
    },
    {
      id: 'meridian-05',
      name: 'Meridian 05',
      family: 'Meridian Series',
      platform: 'meridian-diver',
      purchaseUrl: '/products/meridian-05',
      currentColorways: ['Steel / Blue', 'Gold / Black', 'Rose / Black'],
      currentPrice: 329,
      visibleArchitecture: ['sport case', 'elapsed-time bezel', 'three-hand date layout', 'three-link bracelet'],
      excludedFutureGroups: ['GMT hand stack', '24-hour bezel', 'tachymeter bezel', 'chronograph pushers', 'chronograph dial', 'day-date dial'],
      movementState: 'Verified three-hand date movement.',
      componentOptions: {
        case: [{ value: 'diver sport case', state: 'current' }],
        bezel: [{ value: 'elapsed-time bezel', state: 'current' }],
        dial: [{ value: 'three-hand date dial', state: 'current' }],
        crown: [{ value: 'matching diver-case crown', state: 'current' }],
        calendarFunction: [{ value: 'date', state: 'current' }],
        bracelet: [{ value: 'three-link bracelet', state: 'current' }],
        finish: [{ value: 'current Colorway treatments', state: 'current' }],
        movement: [{ value: 'verified three-hand date movement', state: 'current' }]
      }
    },
    {
      id: 'pulse-06',
      name: 'Pulse 06',
      family: 'Pulse Series',
      platform: 'pulse-chronograph',
      purchaseUrl: '/products/pulse-06',
      currentColorways: ['Two-Tone / Black', 'Gold / Champagne', 'Rose / Black', 'Rose / Brown'],
      currentPrice: 349,
      visibleArchitecture: ['chronograph pushers', 'tachymeter scale', 'multi-register dial', 'sport bracelet'],
      excludedFutureGroups: ['three-hand date dial', 'day-date dial', 'GMT hand stack', '24-hour bezel', 'NH35'],
      movementState: 'Verified chronograph movement.',
      componentOptions: {
        case: [{ value: 'chronograph case', state: 'current' }],
        bezel: [{ value: 'tachymeter scale', state: 'current' }],
        dial: [{ value: 'multi-register chronograph dial', state: 'current' }],
        crown: [{ value: 'chronograph crown and pushers', state: 'current' }],
        calendarFunction: [{ value: 'chronograph', state: 'current' }],
        bracelet: [{ value: 'sport bracelet', state: 'current' }],
        finish: [{ value: 'current Colorway treatments', state: 'current' }],
        movement: [{ value: 'verified chronograph movement', state: 'current' }]
      }
    }
  ]
};
